/* eslint-disable */
export const START_LOAD_MATERIALS = 'START_LOAD_MATERIALS';
export const ERROR_LOAD_MATERIALS = 'ERROR_LOAD_MATERIALS';
export const FINISH_LOAD_MATERIALS = 'FINISH_LOAD_MATERIALS';



export const START_LOAD_NEWS = 'START_LOAD_NEWS';
export const ERROR_LOAD_NEWS = 'ERROR_LOAD_NEWS';
export const FINISH_LOAD_NEWS = 'FINISH_LOAD_NEWS';



// WEBPACK FOOTER //
// ./src/models/materials/constants.js